/* MaxBotix search 1.9.3: predictive request normalization, full SKU preserved visually.
   No external dependencies. Replace previous maxbotix-search-normalizer.js. */
(function () {
  'use strict';
  if (window.MaxBotixSearch && window.MaxBotixSearch.version === '1.9.3') return;
  var aliases = Object.assign(Object.create(null), window.MaxBotixSearchAliases || {});
  var originalParameter = 'mb_original';
  // These identifiers are product cross-references, NOT configuration validation.
  var primaryAccessories = Object.freeze({
    MB7951: 'MB7950', MB7952: 'MB7950', MB7953: 'MB7950',
    MB7991: 'MB7990', MB7992: 'MB7990'
  });
  var alternateAccessories = Object.freeze({
    MB7951: ['MB7993'], MB7952: ['MB7993'], MB7953: ['MB7993'],
    MB7991: ['MB7993'], MB7992: ['MB7993']
  });
  function partIdentifier(raw) {
    var typed = String(raw == null ? '' : raw).trim();
    var clean = typed.replace(/^MB[\s-]*/i, '').toUpperCase();
    if (/^P?\d{4,5}$/.test(clean)) return 'MB' + clean;
    // Permit an unfinished suffix while typing (7851-, 7851-B, MB7851-B).
    // Standalone text queries are unchanged. This is base-family routing, not SKU validation.
    var partial = /^(P?\d{4,5})[\s-]+([A-G]?)$/.exec(clean);
    if (partial) return 'MB' + partial[1];
    var separated = /^(P?\d{4,5})[\s-]+([A-G]?\d{1,10}[A-G]?)$/.exec(clean);
    if (separated) return 'MB' + separated[1];
    var compact = /^(\d{4})([A-G]?\d{2,10}[A-G]?|[A-G]\d[A-G]?)$/.exec(clean);
    if (compact) return 'MB' + compact[1];
    return null;
  }
  function recommendationIds(raw) {
    var id = partIdentifier(raw);
    if (!id) return [];
    var primary = Object.prototype.hasOwnProperty.call(primaryAccessories, id) ? primaryAccessories[id] : id;
    primary = Object.prototype.hasOwnProperty.call(aliases, primary) ? aliases[primary] : primary;
    var extras = alternateAccessories[id] || [];
    return [primary].concat(extras.filter(function (value) { return value !== primary; }));
  }

  function normalize(raw) {
    var typed = String(raw == null ? '' : raw).trim();
    var matches = recommendationIds(typed);
    return matches.length ? matches[0] : typed;
  }
  function check(query) {
    var typed = String(query == null ? '' : query).trim();
    var normalized = normalize(typed);
    return { typed: typed, normalized: normalized, rewritten: normalized !== typed };
  }
  function isPredictivePath(path) {
    return /\/(?:search\/suggest|search\/suggest\.json)\/?$/i.test(path);
  }
  function rewritePredictiveURL(value) {
    if (typeof value !== 'string') return value;
    var url;
    try { url = new URL(value, window.location.href); } catch (e) { return value; }
    if (url.origin !== window.location.origin || !isPredictivePath(url.pathname)) return value;
    var typed = url.searchParams.get('q');
    if (!typed) return value;
    var base = normalize(typed);
    if (base === typed) return value;
    url.searchParams.set('q', base);
    // Retain relative URLs when the theme supplied a relative URL.
    return /^https?:\/\//i.test(value) ? url.toString() : url.pathname + url.search + url.hash;
  }

  // Native predictive-search.js handles normalization, caching, aborts and display.
  // No window.fetch interception or prototype monkey-patching in v1.9.

  window.MaxBotixSearch = {
    version: '1.9.3', normalize: normalize, check: check,
    predictiveURL: rewritePredictiveURL, recommendationIds: recommendationIds,
    isAccessory: function (id) { return accessoryNumbers.has(String(id).toUpperCase()); }
  };

  function isSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    try {
      var url = new URL(form.action, window.location.href);
      return url.origin === window.location.origin && /\/search\/?$/.test(url.pathname);
    } catch (e) { return false; }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isSearchForm(form)) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || input.disabled) return;
    var typed = input.value.trim();
    var normalized = normalize(typed);
    if (!typed || typed === normalized) return;
    var original = form.querySelector('input[name="' + originalParameter + '"]');
    if (!original) {
      original = document.createElement('input');
      original.type = 'hidden';
      original.name = originalParameter;
      form.appendChild(original);
    }
    original.value = typed;
    input.value = normalized;
  }, true);

  function findMatchingProduct(base) {
    var cards = document.querySelectorAll('#product-grid .card-wrapper, .template-search .card-wrapper, main .product-card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var link = card.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"]');
      if (!link) continue;
      var title = (link.textContent || '').trim().replace(/\s+/g, ' ');
      // Match a true part-number token, not MB73890 or an unrelated description.
      var words = title.toUpperCase().match(/MBP?\d{4,5}(?!\d)/g) || [];
      if (words.indexOf(base.toUpperCase()) === -1) continue;
      var url;
      try { url = new URL(link.getAttribute('href'), window.location.href); } catch (e) { continue; }
      if (url.origin !== window.location.origin || !/^\/products\//.test(url.pathname)) continue;
      var image = card.querySelector('img');
      var price = card.querySelector('.price__sale:not(.hidden) .price-item--sale, .price__regular .price-item--regular, .price-item--regular');
      var priceText = price && price.textContent.trim().replace(/\s+/g, ' ');
      // Treat exactly zero-valued displayed prices as missing. Do not hide items
      // with unknown prices or hide a legitimately priced product.
      if (priceText && /^(?:From\s+)?(?:[$€£]\s*)?0(?:[.,]0{1,2})?\s*(?:USD|EUR|GBP)?$/i.test(priceText)) priceText = null;
      return { title: title, href: url.pathname + url.search, image: image, price: priceText };
    }
    return null;
  }

  var accessoryNumbers = new Set(['MB7950','MB7940','MB7974','MB7990','MB7993','MB7961','MB7962','MB7963','MB7964','MB7965']);
  function isAccessory(base) { return accessoryNumbers.has(String(base).toUpperCase()); }

  // Let the Refresh theme control predictive dropdown visibility. Earlier
  // freshness handling set display:none!important on the results panel and
  // could prevent ALL subsequent suggestions from being displayed.

  function initResults() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    var typed = params.get(originalParameter);
    if (!typed || typed.length > 100) return;
    var base = normalize(typed);
    if (!base || base === typed || params.get('q') !== base) return;
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/search"] input[name="q"]'), function (input) {
      if (isSearchForm(input.form)) input.value = typed;
    });
    var target = document.querySelector('#MainContent') || document.querySelector('main');
    if (!target || document.getElementById('maxbotix-search-interpretation')) return;
    var message = document.createElement('aside');
    message.id = 'maxbotix-search-interpretation';
    var accessory = isAccessory(base);
    var recommendations = recommendationIds(typed);
    var alternatives = recommendations.slice(1);
    message.setAttribute('aria-label', accessory ? 'Matched MaxBotix accessory' : 'Matched MaxBotix sensor family');
    message.style.cssText = 'box-sizing:border-box;max-width:1200px;margin:20px auto;padding:16px 20px;border:1px solid #9dd1a3;border-left:4px solid #559659;border-radius:8px;background:#f7fbf7;color:inherit;font:inherit;';
    var title = document.createElement('strong');
    title.textContent = (accessory ? 'Product match' : 'Sensor family match') + ' for “' + typed + '”';
    title.style.cssText = 'display:block;font-size:1.1em;margin-bottom:6px;';
    var description = document.createElement('p');
    description.style.cssText = 'margin:4px 0 12px;';
    description.textContent = accessory
      ? 'We matched your part number to ' + base + (alternatives.length ? '. You may also want to see ' + alternatives.join(', ') : '') + '. Select a product to review its details; the exact suffix has not been verified.'
      : 'We matched your part number to ' + base + '. The exact configuration suffix has not been verified.';
    message.appendChild(title);
    message.appendChild(description);

    // Reuse the product data Shopify actually rendered on the search page.
    // Never guess the product URL, image, price, or validity of an LPO suffix.
    var matched = findMatchingProduct(base);
    if (matched) {
      var product = document.createElement('a');
      product.href = matched.href;
      product.style.cssText = 'display:flex;flex-wrap:wrap;align-items:center;gap:16px;padding:12px;border:1px solid #d8e5d8;border-radius:8px;background:#fff;color:inherit;text-decoration:none;max-width:660px;';
      if (matched.image) {
        var img = document.createElement('img');
        img.src = matched.image.currentSrc || matched.image.src;
        img.alt = matched.image.alt || matched.title;
        img.loading = 'eager';
        img.style.cssText = 'width:110px;height:110px;max-width:25vw;object-fit:contain;flex:none;';
        product.appendChild(img);
      }
      var details = document.createElement('span');
      details.style.cssText = 'display:flex;flex-direction:column;gap:5px;min-width:180px;flex:1;';
      var badge = document.createElement('span');
      badge.textContent = 'Matching product';
      badge.style.cssText = 'color:#407b45;font-size:.85em;font-weight:600;';
      var name = document.createElement('strong');
      name.textContent = matched.title;
      if (matched.price) {
        var price = document.createElement('span');
        price.textContent = matched.price;
        details.appendChild(badge);
        details.appendChild(name);
        details.appendChild(price);
      } else {
        details.appendChild(badge);
        details.appendChild(name);
      }
      var action = document.createElement('span');
      action.textContent = accessory ? 'View product details →' : 'View product and configuration options →';
      action.style.cssText = 'color:#407b45;font-weight:600;';
      details.appendChild(action);
      product.appendChild(details);
      message.appendChild(product);
    } else {
      var hint = document.createElement('p');
      hint.style.cssText = 'margin:4px 0 0;';
      hint.textContent = accessory ? 'Review the Shopify results below to select the matching product.' : 'Review the Shopify product results below to select the matching sensor.';
      message.appendChild(hint);
    }
    target.insertBefore(message, target.firstChild);

    // Alternate accessory recommendations are retrieved from Shopify's OWN
    // predictive products endpoint. Never invent links, prices, or images.
    // The standard search result remains visible even if this fetch fails.
    if (alternatives.length) {
      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'display:flex;flex-wrap:wrap;gap:12px;margin-top:12px;';
      var heading = document.createElement('strong');
      heading.textContent = 'Also recommended';
      heading.style.cssText = 'display:block;margin-top:12px;';
      message.appendChild(heading);
      message.appendChild(wrapper);
      alternatives.forEach(function (part) {
        var found = findMatchingProduct(part);
        if (found) { appendAlternate(wrapper, found, part); return; }
        loadAlternate(part).then(function (product) {
          if (product) appendAlternate(wrapper, product, part);
        }).catch(function () { /* No false positive or broken link. */ });
      });
    }
  }
  function appendAlternate(wrapper, matched, part) {
    if (wrapper.querySelector('[data-mb-recommendation="' + part + '"]')) return;
    var link = document.createElement('a');
    link.dataset.mbRecommendation = part;
    link.href = matched.href;
    link.style.cssText = 'display:flex;align-items:center;gap:12px;padding:12px;border:1px solid #d8e5d8;border-radius:8px;background:#fff;color:inherit;text-decoration:none;max-width:600px;flex:1 1 290px;';
    if (matched.image) {
      var img = document.createElement('img');
      img.src = typeof matched.image === 'string' ? matched.image : (matched.image.currentSrc || matched.image.src);
      img.alt = matched.title;
      img.loading = 'lazy';
      img.style.cssText = 'width:76px;height:76px;object-fit:contain;flex:none;';
      link.appendChild(img);
    }
    var label = document.createElement('span');
    label.style.cssText = 'display:flex;flex-direction:column;gap:4px;';
    var title = document.createElement('strong');
    title.textContent = matched.title;
    label.appendChild(title);
    if (matched.price) { var price = document.createElement('span'); price.textContent = matched.price; label.appendChild(price); }
    var cta = document.createElement('span');
    cta.textContent = 'View product details →';
    cta.style.cssText = 'color:#407b45;font-weight:600;';
    label.appendChild(cta);
    link.appendChild(label);
    wrapper.appendChild(link);
  }
  function loadAlternate(part) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(part) + '&resources[type]=product&resources[limit]=10';
    return window.fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (json) {
      var products = json && json.resources && json.resources.results && json.resources.results.products;
      if (!Array.isArray(products)) return null;
      for (var i = 0; i < products.length; i++) {
        var item = products[i];
        var title = String(item.title || '');
        // Do not recommend a different model due to fuzzy Shopify ranking.
        var tokens = title.toUpperCase().match(/MBP?\d{4,5}(?!\d)/g) || [];
        if (tokens.indexOf(part) === -1) continue;
        var dest;
        try { dest = new URL(item.url, window.location.origin); } catch (e) { continue; }
        if (dest.origin !== window.location.origin || !/^\/products\//.test(dest.pathname)) continue;
        var src = item.image || item.featured_image || '';
        if (typeof src === 'object') src = src.url || src.src || '';
        if (typeof src === 'string' && /^\/\//.test(src)) src = 'https:' + src;
        if (typeof src === 'string' && /^\//.test(src)) src = window.location.origin + src;
        if (src) {
          try { var imgURL = new URL(src); if (imgURL.protocol !== 'https:' && imgURL.protocol !== 'http:') src = ''; }
          catch (e) { src = ''; }
        }
        return { title: title, href: dest.pathname + dest.search, image: src, price: null };
      }
      return null;
    });
  }
  function initialize() { initResults(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
